import axios from 'axios';
import storage from 'store';
import store from '@/store';
import { key } from '@/config';
import * as judgeType from '@/utils/judgeDataType';
import { message, Modal } from 'ant-design-vue';
import NProgress from 'nprogress'; // 引入nprogress插件
import 'nprogress/nprogress.css'; // 这个nprogress样式必须引入
import router from '@/router/index';
import qs from 'qs';
import { sortParams } from '@/utils/sign';
import login from '@/utils/login';

let loadingInstalce = null;
let stepNum = 0; // 请求计步器
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL; // 配置axios请求的地址
// axios.defaults.baseURL = 'http://api.dev.medcon.net.cn/' // 配置axios请求的地址
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 获取请求域名
let isGetBaseUrl = false;
const __getBaseUrl = async () => {
    let baseUrl = process.env.BASE_URL;
    if (!store.getters.baseUrl && !isGetBaseUrl) {
        isGetBaseUrl = true;
        return new Promise(resolve => {
            axios({
                url: 'api/GetApiConfig',
                method: 'get'
            })
                .then(res => {
                    baseUrl = res.data.applet_api_url || baseUrl;
                    store.commit('updateState', {
                        baseUrl
                    });
                    resolve(baseUrl);
                })
                .catch(() => {
                    resolve(baseUrl);
                });
        });
    } else {
        resolve(store.getters.baseUrl);
    }
};

// 请求拦截器
/**
 * costom 参数
 * {
 *   back : 返回上一页
 *   hideModal ： 是否显示非200弹框
 *   notHeader : 是否去掉请求头信息
 * }
 */
axios.interceptors.request.use(
    async config => {
        let { method, url, costom } = config;
        // 获取接口域名 ，需要等待
        // const isProduction = process.env.NODE_ENV === 'production';
        // if(isProduction){
        //     if (url !== "api/GetApiConfig" && !store.getters.baseUrl) {
        //         let baseUrl = await __getBaseUrl();
        //         config.baseURL = baseUrl;
        //     }
        //     if(store.getters.baseUrl){
        //         config.baseURL = store.getters.baseUrl
        //     }
        // }
        if (costom && costom.timeout) {
            config.timeout = costom.timeout;
        }

        // 计步器加1
        if (stepNum == 0 && !costom?.hideLoading) {
            // 打开loading
            NProgress.start();
            //loadingInstalce && loadingInstalce(0);
            //loadingInstalce = message.loading({ duration:0,content: 'Loading...' });
        }
        ++stepNum;

        /****************    参数处理    ******************/
        let requestData = method == 'get' ? 'params' : 'data';
        // 防止空对象
        !config.data && (config.data = {});
        !config.params && (config.params = {});
        // 添加时间戳
        config[requestData]['time'] = parseInt(+(new Date() / 1000));
        // 为了与后端签名一致，需要做以下处理
        for (let key in config[requestData]) {
            // 将boolean类型转换成字符串
            if (judgeType.isBool(config[requestData][key])) {
                config[requestData][key] = String(config[requestData][key]);
            }
            // 将undefined null 这是为空字符串
            if (config[requestData][key] == undefined || config[requestData][key] == null) {
                config[requestData][key] = '';
            }
        }
        // 添加签名
        config[requestData]['__sign'] = sortParams(config[requestData]);
        if (method == 'post' && !config.costom?.isFormData && !config.url.includes(process.env.VUE_APP_API_GO_BASE_URL)) {
            config.data = qs.stringify(config.data);
        }
        // if (method == 'post' && !config.url.includes(process.env.VUE_APP_API_GO_BASE_URL)) {
        //     config.data = qs.stringify(config.data);
        // }
        /****************    参数处理    ******************/

        /****************    请求头处理    ******************/
        const token = storage.get('token');
        let { meeting_id, lang, forum_id } = router.currentRoute.params;

        config.headers['key'] = key;
        let { m_committee_id } = store.state?.meetingInfo || {};
        m_committee_id && (config.headers['committeeID'] = m_committee_id);
        token && (config.headers['auth'] = token);
        meeting_id && (config.headers['meetingID'] = config.headers['meetingID'] || meeting_id);
        meeting_id && (config.headers['mid'] = config.headers['meetingID'] || meeting_id);
        lang && (config.headers['language'] = lang);
        forum_id && (config.headers['forumID'] = forum_id);

        /****************    请求头处理    ******************/
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

axios.interceptors.response.use(
    response => {
        let costom = response?.config?.costom || {};
        // 计步器减一
        --stepNum;
        if (stepNum == 0 && !costom.hideLoading) {
            // 关闭loading
            NProgress.done();
            // 关闭toast
            //loadingInstalce && loadingInstalce(0);
        }
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            // 统一处理非200提示
            let { code, message } = response.data;
            // hideModal 如果为true则隐藏错误弹框
            if (code != 200 && code != 100000 && !costom.hideModal) {
                Modal.error({
                    title: window.$i18n.t('web.tips' /* 提示 */),
                    content: message || window.$i18n.t('web.unknown_problem' /* 未知问题 */),
                    okText: window.$i18n.t('web.ok' /* 确定 */),
                    onOk() {
                        costom.back && router.back();
                    }
                });
                return Promise.reject(response.data);
            }
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        console.log(error);
        let costom = error.response?.config?.costom || {};
        // 错误后关闭所有loading
        // 计步器减一
        --stepNum;
        if (stepNum == 0) {
            // 关闭loading
            NProgress.done();
            // 关闭toast
            loadingInstalce && loadingInstalce(0);
        }
        if (error.response && error.response.status) {
            let prevRoute = router.currentRoute.fullPath == '/' ? router.history.pending : router.currentRoute;
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    //if (!costom.hideModal) {
                    //message.error('身份验证失败');
                    // token已过期 此时退出登录
                    //}
                    login();
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    // message.error("登录过期，请关闭重新进入。");
                    // token已过期 此时退出登录
                    // let costom = error.response.config.costom || {}
                    //if (!costom.hideModal) {
                    message.error(window.$i18n.t('web.identity_verification_failed' /* 身份验证失败 */));
                    // token已过期 此时退出登录
                    //}
                    break;

                // 404请求不存在
                case 404:
                    message.error(window.$i18n.t('web.page_not_found' /* 您访问的网页不存在。 */));
                    break;

                // 404请求不存在
                case 500:
                    message.error(window.$i18n.t('web.data_loading_error' /* 数据加载出错 */));
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    message.error(error.response.data.message);
            }
            return Promise.reject(error.response);
        }
    }
);
export default axios;
